import { trackProductEvent, type AnalyticsProperties } from '@/lib/analytics';

export const trackDashboardTabSwitched = (properties: AnalyticsProperties) => {
  trackProductEvent('Dashboard Tab Switched', properties);
};
